import { Module } from "vuex";
import { RootState } from "@/store/";

export interface NavigationState {
  aboutParentPage: string;
  detailParentPage: string;
}

export const NagivationStore: Module<NavigationState, RootState> = {
  namespaced: true,
  state: {
    aboutParentPage: "/",
    detailParentPage: "/"
  },
  mutations: {
    setAboutParentPage(state, path) {
      state.aboutParentPage = path;
    },
    setDetailParentPage(state, path) {
      state.detailParentPage = path;
    }
  }
};
